import apiClient from "./client";
import type {
  DivisionCodePrefsResponse,
  GetDivisionCodePrefsParams,
} from "../types/division-code";

export const getDivisionCodePrefs = async (
  params: GetDivisionCodePrefsParams
): Promise<DivisionCodePrefsResponse> => {
  const { data } = await apiClient.get<DivisionCodePrefsResponse>(
    "/division-code-prefs",
    {
      params: {
        disaster_id: params.disaster_id,
        m_branch_id: params.m_branch_id,
        m_customer_id: params.m_customer_id,
        order: params.order,
        sort: params.sort,
        page: params.page,
      },
    }
  );
  return data;
};
